import { Phone, MessageCircle } from "lucide-react";

/*
 * LocationCTA — Section 10/10 for /garage-door-repair-canterbury-bankstown/
 * MASTER TEMPLATE — duplicate for other locations, change only the LOC block.
 * Paste this ENTIRE file into src/pages/GarageDoorRepairCanterburyBankstown/sections/LocationCTA.tsx
 */

// ╔══════════════════════════════════════════════════════════════════╗
// ║  LOC CONFIG — change ONLY this block when duplicating          ║
// ╚══════════════════════════════════════════════════════════════════╝
const LOC = {
  name: "Canterbury-Bankstown",
  h2Line1: "Need a Garage Door Fix",
  h2Line2: "in Canterbury-Bankstown?",
  subtitle: "Call your local team — we\'re based in Bass Hill. Same-day service across Bankstown, Canterbury, Revesby and all of Canterbury-Bankstown.",
  whatsapp: "Hi Gold Garage Door, I need a quote for a garage door repair in Canterbury-Bankstown."
};
// ╚══════════════════════════════════════════════════════════════════╝

const GOLD = "#F5A623";
const NAVY = "#081438";
const NAVY2 = "#060f2a";
export default function LocationCTA() {
  const waUrl = `https://wa.me/61485000933?text=${encodeURIComponent(LOC.whatsapp)}`;
  return <section id="location-cta" style={{
    background: NAVY2,
    position: "relative",
    overflow: "hidden"
  }}>

      {/* Wave top — DUPLICATE from LocationFAQ bottom */}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,60 C360,0 1080,0 1440,60 L1440,0 L0,0 Z" fill="#FAF7F1" />
        </svg>
      </div>

      {/* Grain */}
      <svg aria-hidden="true" style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none",
      zIndex: 1
    }}>
        <filter id="lcta-grain"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#lcta-grain)" />
      </svg>

      {/* Gold radial glow */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      width: "600px",
      height: "600px",
      background: `radial-gradient(ellipse,${GOLD}12 0%,transparent 70%)`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      {/* Scanline top */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "2px",
      background: `linear-gradient(90deg,transparent,${GOLD},transparent)`,
      zIndex: 2
    }} />

      <div style={{
      position: "relative",
      zIndex: 3,
      maxWidth: "720px",
      margin: "0 auto",
      padding: "clamp(64px,8vw,100px) clamp(20px,5vw,48px)",
      textAlign: "center"
    }}>

        {/* Eyebrow */}
        <div style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "24px"
      }}>
          <div style={{
          width: "32px",
          height: "2px",
          background: GOLD
        }} />
          <span style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: `${GOLD}BB`
        }}>
            {LOC.name} · Same-Day Service
          </span>
          <div style={{
          width: "32px",
          height: "2px",
          background: GOLD
        }} />
        </div>

        {/* Headline */}
        <h2 style={{
        fontFamily: "Plus Jakarta Sans,sans-serif",
        fontWeight: 800,
        fontSize: "clamp(28px,4vw,48px)",
        lineHeight: 1.1,
        color: "#FFFFFF",
        marginBottom: "18px"
      }}>
          {LOC.h2Line1}<br />
          <span style={{
          color: GOLD
        }}>{LOC.h2Line2}</span>
        </h2>

        <p style={{
        fontFamily: "Manrope,sans-serif",
        fontSize: "clamp(15px,1.7vw,18px)",
        color: "rgba(255,255,255,0.7)",
        lineHeight: 1.7,
        marginBottom: "36px",
        maxWidth: "500px",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
          {LOC.subtitle}
        </p>

        {/* Triple CTA */}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        justifyContent: "center",
        marginBottom: "32px"
      }}>
          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          background: GOLD,
          color: NAVY,
          padding: "15px 28px",
          borderRadius: "8px",
          fontFamily: "Manrope,sans-serif",
          fontWeight: 700,
          fontSize: "16px",
          textDecoration: "none",
          boxShadow: `0 4px 24px ${GOLD}50`
        }}>
            {/** @preserve lucide-do-not-replace */}
            <span data-icon-container="lucide-do-not-replace"><Phone size={18} color={NAVY} strokeWidth={2.5} /></span>
            0485 000 933
          </a>
          <a href={waUrl} style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          background: "#25D366",
          color: NAVY,
          padding: "15px 24px",
          borderRadius: "8px",
          fontFamily: "Manrope,sans-serif",
          fontWeight: 700,
          fontSize: "15px",
          textDecoration: "none"
        }}>
            {/** @preserve lucide-do-not-replace */}
            <span data-icon-container="lucide-do-not-replace"><MessageCircle size={18} color={NAVY} strokeWidth={2.5} /></span>
            <span style={{
            color: NAVY
          }}>WhatsApp Us</span>
          </a>
          <a href="#contact-us" style={{
          display: "inline-flex",
          alignItems: "center",
          background: "rgba(255,255,255,0.08)",
          color: "#FFF",
          border: "1.5px solid rgba(255,255,255,0.22)",
          padding: "15px 24px",
          borderRadius: "8px",
          fontFamily: "Manrope,sans-serif",
          fontWeight: 600,
          fontSize: "15px",
          textDecoration: "none"
        }}>
            Get Free Quote
          </a>
        </div>

        {/* Trust badges */}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        justifyContent: "center"
      }}>
          {["1-Year Labour Warranty", "Same-day service", "Fixed-price quotes", "Family-run since 2009"].map(t => <div key={t} style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "5px"
        }}>
              <span style={{
            color: GOLD,
            fontSize: "12px"
          }}>✓</span>
              <span style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "12px",
            color: "rgba(255,255,255,0.55)",
            fontWeight: 500
          }}>{t}</span>
            </div>)}
        </div>
      </div>

      {/* Bottom scanline */}
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "2px",
      background: `linear-gradient(90deg,transparent,${GOLD},transparent)`,
      zIndex: 2
    }} />
    </section>;
}